import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../components/Loader";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import Header from "../../components/user/Header";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/user/Footer";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AthleteProfile() {
  const getUsername = Cookies.get("username");
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [payments, setPayments] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(true);

  const [refundModal, setRefundModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if(!getUsername){
          navigate('/login');
        }
        else{
          // 1️⃣ Get current user data
          const usersRes = await axios.get(`${BASE_URL}/getusers`, {
            headers: {
              Authorization: apiKey,
              "Content-Type": "application/json",
            },
          });

          const currentUser = usersRes.data.find((u) => u.Name === getUsername);

          if (!currentUser) {
            toast.error("User not found!");
            setLoading(false);
            return;
          }

          setUser(currentUser);

          // 2️⃣ Fetch user certificates
          const playersRes = await axios.get(`${BASE_URL}/getplayers`, {
            headers: {
              Authorization: apiKey,
              "Content-Type": "application/json",
            },
          });

          const userCertificates = playersRes.data.filter(
            (p) => p.Email === currentUser.Email
          );

          setPlayers(userCertificates);
          setLoading(false);

          // 3️⃣ Fetch user payments
          const payRes = await axios.get(`${BASE_URL}/getpayments`, {
            headers: {
              Authorization: apiKey,
              "Content-Type": "application/json",
            },
          });

          const myPayments = payRes.data.filter(
            (p) => p.email === currentUser.Email
          );

          setPayments(myPayments);
          setPaymentLoading(false);
        }

      } catch (err) {
        console.error("Error fetching data:", err);
        toast.error("Failed to fetch data");
        setLoading(false);
      }
    };

    fetchData();
  }, [getUsername]);
  
  const openRefundModal = (payment) => {
    setSelectedPayment(payment);
    setRefundModal(true);
  };

  const submitRefund = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);

    const reason = form.get("reason");
    const message = form.get("message");

    try {
      const res = await axios.post(
        `${BASE_URL}/addrefund`,
        {
          transactionId: selectedPayment.transactionId,
          reason,
          message,
        },
        {
          headers: { Authorization: apiKey },
        }
      );

      toast.success("Refund request submitted!");
      setRefundModal(false);

      // Disable button by updating local state
      setPayments((prev) =>
        prev.map((p) =>
          p.transactionId === selectedPayment.transactionId
            ? { ...p, refundRequest: { status: "pending", reason, message } }
            : p
        )
      );
    } catch (err) {
      toast.error("Failed to submit refund");
      console.log(err);
    }
  };


  // ✅ Handle update profile
  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    const data = {
      Id: user.Id,
      Name: formData.get("Name"),
      FirstName: formData.get("FirstName"),
      LastName: formData.get("LastName"),
      Email: formData.get("Email"),
      DateOfBirth: formData.get("DateOfBirth"),
      JerseyNumber: formData.get("JerseyNumber"),
      Address: formData.get("Address"),
      SchoolClub: formData.get("SchoolClub"),
      GraduationYear: formData.get("GraduationYear"),
      oldPassword: formData.get("oldPassword"),
      newPassword: formData.get("newPassword"),
    };

    try {
      const res = await axios.put(`${BASE_URL}/updateuser`, data, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      });

      if (res.data.message === "User Profile Updated Successfully.") {
        toast.success("Profile updated successfully!");
        let date = new Date();
        date.setTime(date.getTime() + 5 * 60 * 60 * 1000);
        Cookies.set("username", data.Name, { expires: date });
        setTimeout(() => navigate("/"), 2000);
      } else {
        toast.error(res.data.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Update failed");
    }
  };

  const LOGOUT_URL = BASE_URL + "/logout";
  const logout = () => {
    axios
      .post(
        LOGOUT_URL,
        [],
        {
          headers: {
            Authorization: apiKey,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        Cookies.remove("username");
        Cookies.remove("user_role");
        navigate("/");
      })
      .catch((error) => console.error(error));
  };

  if (loading) return <Loader />;

  // Helper function to determine if a tier should be disabled
  const isTierDisabled = (tier) => {
    if (!user?.Tier) return false;
    if (user.Tier === "Silver") return tier !== "Gold";
    if (user.Tier === "Gold") return tier !== "Platinum";
    if (user.Tier === "Platinum") return true; // All disabled
    return false;
  };

  return (
    <>
      <Header />
      <br />
      <div className="container">
        <ToastContainer position="top-center" />

        {/* ✅ Update Profile Section */}
        <h2>My Profile</h2>
        <form onSubmit={handleUpdate}>
          <input type="hidden" name="Id" value={user?.Id} />
          <div className="row">
            <div className="col-sm-6">
              <input
                type="text"
                name="Name"
                className="form-control"
                defaultValue={user?.Name}
                required
              />
            </div>
            <div className="col-sm-6">
              <input
                type="text"
                name="FirstName"
                className="form-control"
                defaultValue={user?.FirstName}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              <input
                type="text"
                name="LastName"
                className="form-control"
                defaultValue={user?.LastName}
                required
              />
            </div>
            <div className="col-sm-6">
              <input
                type="email"
                name="Email"
                className="form-control"
                defaultValue={user?.Email}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              <input
                type="date"
                name="DateOfBirth"
                className="form-control"
                defaultValue={user?.DateOfBirth}
                required
              />
            </div>
            <div className="col-sm-6">
              <input
                type="text"
                name="JerseyNumber"
                className="form-control"
                defaultValue={user?.JerseyNumber}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              <input
                type="text"
                name="Address"
                className="form-control"
                defaultValue={user?.Address}
                required
              />
            </div>
            <div className="col-sm-6">
              <input
                type="text"
                name="SchoolClub"
                className="form-control"
                defaultValue={user?.SchoolClub}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              <input
                type="text"
                name="GraduationYear"
                className="form-control"
                defaultValue={user?.GraduationYear}
                required
              />
            </div>
            <div className="col-sm-3">
              <input
                type="password"
                name="oldPassword"
                className="form-control"
                placeholder="Old Password"
              />
            </div>
            <div className="col-sm-3">
              <input
                type="password"
                name="newPassword"
                className="form-control"
                placeholder="New Password"
              />
            </div>
          </div>
          <br />
          <button className="btn btn-primary">Update Profile</button>
        </form>

        <hr />

        {/* ================= Tier Info Section ================= */}
        {user?.Tier && user?.DiscountCode && (
          <div
            className="tier-section my-4 p-3 border rounded"
            style={{ backgroundColor: "#f9f9f9" }}
          >
            <h3>My Tier Information</h3>
            <div className="d-flex align-items-center">
              {/* Tier Image */}
              <img
                src={
                  user.Tier === "Platinum"
                    ? "/images/platinum.png"
                    : user.Tier === "Gold"
                    ? "/images/gold.png"
                    : "/images/silver.png"
                }
                alt={`${user.Tier} Tier`}
                style={{ width: "80px", marginRight: "20px" }}
              />

              <div>
                <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Tier: <span style={{ color: "#333" }}>{user.Tier}</span>
                </p>
                <p style={{ fontSize: "16px" }}>
                  Discount Code:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {user.DiscountCode.code}
                  </span>
                </p>
                <p style={{ fontSize: "14px", color: "#666" }}>
                  Expiry Date:{" "}
                  {new Date(
                    user.DiscountCode.expiresAt._seconds * 1000
                  ).toLocaleDateString()}
                </p>
              </div>
            </div>

            {/* ✅ Start New NLSA CHALLENGE Button */}
            <button
              className="btn btn-dark mt-3"
              onClick={() => setShowModal(true)}
            >
              Start New NLSA CHALLENGE
            </button>
          </div>
        )}

        {/* ✅ Modal */}
        {showModal && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">NLSA CHALLENGE Tiers</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    {[
                      { name: "Silver", logo: "/images/silver.png", requirement: "1 certified attempt completed" },
                      { name: "Gold", logo: "/images/gold.png", requirement: "5 certified attempts completed" },
                      { name: "Platinum", logo: "/images/platinum.png", requirement: "10 certified attempts completed" }
                    ].map((tier) => {
                      const disabled = isTierDisabled(tier.name);
                      return (
                        <div key={tier.name} className="col-md-4 mb-3">
                          <div
                            className="card text-center h-100"
                            style={{
                              opacity: disabled ? 0.5 : 1,
                              pointerEvents: disabled ? "none" : "auto",
                            }}
                          >
                            <img
                              src={tier.logo}
                              className="card-img-top mx-auto mt-3"
                              alt={tier.name}
                              style={{ width: "80px", height: "80px" }}
                            />
                            <div className="card-body d-flex flex-column justify-content-between">
                              <h5 className="card-title">{tier.name}</h5>
                              <p className="card-text">{tier.requirement}</p>
                              <Link
                                to="/"
                                className={`btn btn-primary mt-2 ${disabled ? "disabled" : ""}`}
                              >
                                Achieve
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ Certificates Section */}
        <h2>My Certificates</h2>
        <br />
        <table className="table table-striped table-light" id="mycertificates">
          <thead>
            <tr>
              <th>Player Name</th>
              <th>Sports Category</th>
              <th>Event Date</th>
              <th>Email</th>
              <th>Status</th>
              <th>View Certificate</th>
            </tr>
          </thead>
          <tbody>
            {players.map((player) => (
              <tr key={player.Id}>
                <td>{player.PlayerName}</td>
                <td>{player.SportCategory}</td>
                <td>{player.EventDate}</td>
                <td>{player.Email}</td>
                <td
                  style={{
                    color:
                      player.Status === "Approved"
                        ? "#0da731ff"
                        : player.Status === "Rejected"
                        ? "#e40017ff"
                        : "#e2ab06ff",
                    fontWeight: "bold",
                  }}
                >
                  {player.Status}
                </td>
                <td>
                  <a
                    href={
                      player.Status === "Approved"
                        ? `${BASE_URL}/certificate/${player.Id}`
                        : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`btn btn-dark btn-sm ${
                      player.Status !== "Approved" ? "disabled" : ""
                    }`}
                  >
                    View
                  </a>
                </td>
              </tr>
            ))}
            {players.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center">
                  No certificates available.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* ====================== My Payments ====================== */}

        <h2 className="mt-5">My Payments</h2>
        <br />

        {paymentLoading ? (
          <Loader />
        ) : (
          <table className="table table-striped table-light">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Event</th>
                <th>Sport</th>
                <th>Status</th>
                <th>Transaction ID</th>
                <th>Refund</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.playerId}>
                  <td>${p.amount}</td>
                  <td>{p.eventName}</td>
                  <td>{p.sport}</td>
                  <td>
                    <span
                      className={`badge ${
                        p.status === "succeeded" ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {p.status}
                    </span>
                  </td>

                  <td style={{ maxWidth: "200px", wordWrap: "break-word" }}>
                    {p.transactionId}
                  </td>

                  <td>
                    {p.status !== "succeeded" ? (
                      <span className="badge bg-secondary">Not Eligible</span>
                    ) : p.refundRequest ? (
                      <button className="btn btn-warning btn-sm" disabled>
                        Refund Requested
                      </button>
                    ) : p.refundAvailable ? (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => openRefundModal(p)}
                      >
                        Request Refund
                      </button>
                    ) : (
                      <span className="badge bg-secondary">Not Available</span>
                    )}
                  </td>
                </tr>
              ))}

              {payments.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">
                    No payments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        <br />
        <Link className="dropdown-item" to="/" onClick={logout}>
          <button className="btn btn-danger">Sign out</button>
        </Link>
        <br />

        {refundModal && selectedPayment && (
        <div
          className="modal show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content p-3">
              <div className="modal-header">
                <h5 className="modal-title">Refund Request</h5>
                <button
                  className="btn-close"
                  onClick={() => setRefundModal(false)}
                ></button>
              </div>

              <form onSubmit={submitRefund}>
                <div className="modal-body">
                  <label>Reason for Refund</label>
                  <select
                    name="reason"
                    className="form-control"
                    required
                  >
                    <option value="">Select reason</option>
                    <option value="Charged Incorrect Amount">
                      Charged Incorrect Amount
                    </option>
                    <option value="Event Cancelled">Event Cancelled</option>
                    <option value="Accidental Payment">Accidental Payment</option>
                    <option value="Other">Other</option>
                  </select>

                  <br />

                  <label>Message</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    required
                  ></textarea>

                  <br />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setRefundModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-danger" type="submit">
                    Submit Refund Request
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      </div>
      <Footer />
    </>
  );
}
